import Vue from "vue";
import VueToast from "vue-toast-notification";

Vue.use(VueToast, {
    position: "bottom"
});

const toast = {
    error: message => {
        return Vue.$toast.error(message);
    },
    success: message => {
        return Vue.$toast.success(message);
    }
};

export default toast;
